"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var compute_scroll_into_view_1 = __importStar(require("./compute-scroll-into-view"));
var isStandardScrollBehavior = function (options) {
    return options === Object(options) && Object.keys(options).length !== 0;
};
var isCustomScrollBehavior = function (options) {
    return typeof options === 'object' ? typeof options.behavior === 'function' : false;
};
var getOptions = function (options) {
    // Handle alignToTop for legacy reasons, to be compatible with the spec
    if (options === false) {
        return { block: 'end', inline: 'nearest' };
    }
    if (isStandardScrollBehavior(options)) {
        // compute.ts ensures the defaults are block: 'center' and inline: 'nearest', to conform to the spec
        return options;
    }
    // if options = {}, options = true or options = null, based on w3c web platform test
    return { block: 'start', inline: 'nearest' };
};
function scrollIntoView(target, options) {
    // Browsers treats targets that aren't in the dom as a no-op and so should we
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if (isCustomScrollBehavior(options)) {
        return options.behavior(isTargetAttached ? (0, compute_scroll_into_view_1.default)(target, options) : []);
    }
    // Don't do anything if using a standard behavior on an element that is not in the document
    if (!isTargetAttached) {
        return;
    }
    var computeOptions = getOptions(options);
    var actions = (0, compute_scroll_into_view_1.default)(target, computeOptions);
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function (_a) {
        var el = _a.el, top = _a.top, left = _a.left;
        // browser implements the new Element.prototype.scroll API that supports `behavior`
        // and guard window.scroll with supportsScrollBehavior
        if (el.scroll && canSmoothScroll) {
            el.scroll({ top: top, left: left, behavior: computeOptions.behavior });
        }
        else {
            el.scrollTop = top;
            (0, compute_scroll_into_view_1.setScrollLeft)(el, left);
        }
    });
}
exports.default = scrollIntoView;
